import 'common/css/app.css'
import './index.css'
import {vUrl} from 'common/js/global.js'

$(function() {
  $(window).resize(function(){
    toggleDom()
    Affix()
  })
  toggleDom()
  Affix()
  wayPoint()
  $(".section .mode-list .mode-item").hover(function() {
    $(this).addClass("active").siblings().removeClass("active");
  })
  mouseXqcList()
  // $('.btn-wrapper').find('.btn2').click(function() {
  //   window.open(vUrl)z
  // })
})
function wayPoint() {
  $('.page').waypoint(function (direction) {
      if (direction === 'down') {
        $(this.element).find('.state').addClass('animated slideInUp')
        $(this.element).find('.stateRight').addClass('animated fadeInRight')
      }
  }, {offset: '70%'});
}

function toggleDom() {
  var windowWidth = $(window).width()
  if(windowWidth <= 768){
    $('#ourAdv1').hide()
    $('#ourAdv2').show()
    $('#model1').hide()
    $('#model2').show()
  }else{
    $('#ourAdv1').show()
    $('#ourAdv2').hide()
    $('#model1').show()
    $('#model2').hide()
  }
}

function Affix(){
  var navTop = $('#navTop').offset().top
  $("#affixBox").affix({
    offset: { 
        top: navTop 
    }
  });
}

function mouseXqcList() {
  $("#xqc li").mouseenter(function(){
    var index = $(this).index() + 1
    $("#xqcImg").attr("src", '../../static/img/sass/xqc'+index+'.png');
  })
  $("#pro li").mouseenter(function(){
    var index = $(this).index() + 1
    $("#proImg").attr("src", '../../static/img/sass/pro'+index+'.png');
  })
  $("#qx li").mouseenter(function(){
    var index = $(this).index() + 1
    $("#qxImg").attr("src", '../../static/img/sass/qx'+index+'.png');
  })
  $("#wechat li").mouseenter(function(){
    var index = $(this).index() + 1
    $("#wechatImg").attr("src", '../../static/img/sass/wechat'+index+'.png');
  })
}




// WEBPACK FOOTER //
// ./src/sass/index.js